import axios from "../utils/axios";

const hasAuthToken = () => Boolean(localStorage.getItem("sva_webapp_token"));

export const chatbotApi = {
  sendMessage: async (message, sessionId) => {
    const endpoint = hasAuthToken() ? "chat" : "chat/public";
    const response = await axios.post(endpoint, {
      message,
      session_id: sessionId,
    });
    return response.data;
  },

  getHistory: async () => {
    const response = await axios.get("chat/history");
    return response.data;
  },

  getSession: async (sessionId) => {
    const response = await axios.get(`chat/session/${sessionId}`);
    return response.data;
  },

  closeSession: async (sessionId) => {
    const response = await axios.post(`chat/session/${sessionId}/close`);
    return response.data;
  },
};

